import {styled, Typography} from "@mui/material";
import {apiGetPermissions} from "api/permissionApi";
import {CheckboxInput} from "components/Input/FormControl";
import {CheckBoxInput} from "components/Input";
import {getAllowedPermissions, permissionSortByKeys} from "helpers/dataFormat";
import {useEffect, useMemo} from "react";
import {useDispatch, useSelector} from "react-redux";

import shortid from "shortid";
import {useParams} from "react-router-dom";
import {updateForm} from "store/actions/formAction";

const LimitationContainer = styled("div")(({theme}) => ({}));
const ItemContainer = styled("div")(({theme}) => ({
    padding: "24px",
}));

interface itemCount {
    count: number;
}

const LimitationItemContainer = styled("div")<itemCount>(({theme, count}) => ({
    paddingTop: "24px",
    height: `${Math.ceil(count / 4) * 100}px`,
    display: "grid",
    gridTemplateColumns: "repeat(auto-fill, 30%)",
    gridColumnGap: "3%",
    gridRowGap: "6%",
    justifyContent: "space-between",
}));

const Limitation = () => {
    const dispatch = useDispatch();
    //@ts-ignore
    const {token} = useSelector((state) => state).businessReducer.business;
    //@ts-ignore
    const permissions = useSelector((state) => state).permissionReducer.permissions;

    //@ts-ignore
    const editItem = useSelector((state) => state).formReducer.editItem;

    //@ts-ignore
    const formData = useSelector((state) => state).formReducer;

    const sortedPermissions = permissionSortByKeys(permissions);

    const {id} = useParams();

    let allowedPermissions = [] as permission[];

    useMemo(() => {
        allowedPermissions = getAllowedPermissions(editItem?.permissions);
    }, [editItem?.permissions]);

    useEffect(() => {
        allowedPermissions.map((permission) => {
            return dispatch(updateForm(permission.id, permission.status));
        });
    }, [allowedPermissions]);
    useEffect(() => {
        // @ts-ignore
        dispatch(apiGetPermissions(token));
    }, []);
    return (
        <LimitationContainer>
            {sortedPermissions.map((item) => (
                <ItemContainer key={shortid.generate()}>
                    <Typography
                        sx={{
                            backgroundColor: "#E8F1FF",
                            padding: "10px",
                            borderRadius: "4px",
                        }}
                        variant="body1"
                    >
                        {item.title}
                    </Typography>

                    <LimitationItemContainer count={item.children.length}>
                        {item.children.map((it) => (
                            <CheckBoxInput
                                key={shortid.generate()}
                                input={{
                                    name: it.id,
                                    label: it.fa_title,
                                }}
                            />
                        ))}
                    </LimitationItemContainer>
                </ItemContainer>
            ))}
        </LimitationContainer>
    );
};

export default Limitation;
